import { CLEAR_ALERT, SET_ALERT } from '../actionTypes';

export const alert = (state = null, action) => {
  switch (action.type) {
    case SET_ALERT:
      return { ...action.payload };
    case CLEAR_ALERT:
      return null;

    default:
      return state;
  }
};
